<template>
  <section class="login-form">
    <form @submit.prevent>
      <div v-if="step === 1">
        <h3 class="login-form__title">{{ $t("register.getYour") }}</h3>
        <p class="login-form__instantly">{{ $t("register.instantly") }}</p>

        <!-- <div class="social_buttons">
        <button class="google-button" @click="doFederatedGoogleLogIn"><img src="/assets/images/google.png" alt="">{{ $t('register.registerGoogle') }}
        </button>
        <button class="facebook-button" @click="doFederatedFacebookLogIn"><img src="/assets/images/facebook.png" alt="">{{ $t('register.registerFacebook') }}
        </button>
      </div> -->

        <!-- <div class="login-form__or">
          <div class="login-form__or__bar"></div>
          <div class="login-form__or__label">{{ $t("register.or") }}:</div>
          <div class="login-form__or__bar"></div>
        </div> -->

        <div class="login-form__form size-grid">
          <div class="form__group field login-form__form__field">
            <input
              type="email"
              id="labelled-field-email"
              name="labelled-field-email"
              class="form__field form__email"
              :placeholder="null"
              v-model="emailModel"
            />
            <label for="labelled-field-email" class="form__label">{{
              $t("register.email")
            }}</label>
          </div>
          <div class="form__group field login-form__form__field">
            <input
              type="password"
              id="labelled-field-password-1"
              name="labelled-field-password-1"
              class="form__field form__email"
              :placeholder="null"
              v-model="password1"
            />
            <label
              for="labelled-field-password-1"
              class="form__label secure_client_password"
              >{{ $t("register.secure") }}<br /><span>{{
                $t("register.length")
              }}</span></label
            >
          </div>
          <div class="form__group field login-form__form__field">
            <input
              type="password"
              id="labelled-field-password-2"
              name="labelled-field-password-2"
              class="form__field form__email"
              :placeholder="null"
              v-model="password2"
            />
            <label for="labelled-field-password-2" class="form__label">{{
              $t("register.confirmPassword")
            }}</label>
          </div>

        <div class="disclaimer" v-if="account">
          <p><b>{{ $t('register.disclaimer') }}</b>{{ $t('register.disclaimerdes1') }}<b> {{ websiteName }}
            Ltd.
            ("Tradeview")</b> {{ $t('register.disclaimerdes2') }} <b> <a
                href="https://documents-eu.s3.eu-central-1.amazonaws.com/Client+Agreement.pdf" target="_blank">{{ $t('register.clientAgree') }} </a> </b></p>
        </div>

          <div class="application-form-input checkbox-input" v-if="account">
            <div class="application-form-input__col none-border">
              <div class="application-form-input__col__content-check">
                <label
                  class="input-checkbox large"
                  :class="{ invalidform: valid }"
                >
                  <input
                    name="purposeAccount"
                    type="checkbox"
                    value="hedging"
                    @change="valid = false"
                    v-model="disclaimer"
                  />
                  <span class="checkmark"></span>{{ $t("register.byTicking") }}
                </label>
              </div>
            </div>
          </div>

          <div
            class="application-form-input checkbox-input divDisclaimer"
            v-if="!account"
          >
            <div class="application-form-input__col none-border">
              <div class="application-form-input__col__content-check">
                <label
                  class="input-checkbox large"
                  :class="{ invalidform: valid }"
                >
                  <input
                    name="purposeAccount"
                    type="checkbox"
                    value="hedging"
                    @change="valid = false"
                    v-model="disclaimer"
                  />
                  <span class="checkmark"></span>{{ $t("register.wish") }}
                  <a
                    style="color: black"
                    href="https://documents-eu.s3.eu-central-1.amazonaws.com/Privacy+Policy.pdf"
                    target="_blank"
                    >{{ $t("register.policity") }}</a
                  >.
                </label>
              </div>
            </div>
          </div>
        </div>

        <button class="red-button" id="btnSubConf" @click="getStartedClicked">
          {{ $t("register.getstarted") }}
        </button>
      </div>
      <div v-else>
        <h3 class="login-form__title2" v-if="region === 'mena'">
          {{ $t("register.titleTwo") }}
        </h3>
        <h3 class="login-form__title2" v-else>
          {{ $t("register.titleTwo") }} <br />{{ $t("register.titleTwob") }}
        </h3>

        <div class="login-form__form">
          <div class="form__group field login-form__form__field">
            <input
              type="email"
              id="labelled-field-email-2"
              name="labelled-field-email-2"
              class="form__field form__email"
              :placeholder="null"
              v-model="emailModel"
              readonly
            />
            <label for="labelled-field-email-2" class="form__label"
              >{{ $t("register.email") }}</label
            >
          </div>

          <div class="form__group field login-form__form__field" v-if="account">
            <CustomSelectorV2
              class="procedural-form__custom-selector"
              label="*account type"
              title="*ACCOUNT TYPE:"
              :options="accountOptions"
              v-model="accountType"
              :closeIfLeft="true"
            ></CustomSelectorV2>
          </div>

          <!-- <div class="form__group field login-form__form__field">
          <CustomSelectorV2
              class="procedural-form__custom-selector"
              label="*country of residence"
              title="*COUNTRY OF RESIDENCE:"
              :options="countryOptions"
              v-model="residence"
              :closeIfLeft="true"
          ></CustomSelectorV2>
        </div> -->

          <div class="form__group field login-form__form__field">
            <input
              type="text"
              id="labelled-field-firstname"
              name="labelled-field-firstname"
              class="form__field form__email"
              :placeholder="null"
              v-model="firstNameModel"
            />
            <label for="labelled-field-firstname" class="form__label"
              >{{ $t("register.name") }}</label
            >
          </div>
          <div class="form__group field login-form__form__field">
            <input
              type="text"
              id="labelled-field-lastname"
              name="labelled-field-lastname"
              class="form__field form__email"
              :placeholder="null"
              v-model="lastNameModel"
            />
            <label for="labelled-field-lastname" class="form__label"
              >{{ $t("register.lastName") }}</label>
          </div>
        </div>

        <!-- <button class="red-button" :class="{'red-button__busy': busy}" @click="registerClicked" :disabled="busy"> -->
        <button
          class="red-button"
          :class="{ 'red-button__busy': busy }"
          @click="registerClicked"
        >
        {{ $t("register.register") }}
        </button>
      </div>
    </form>
  </section>
</template>

<script>
import {
  getCurrentInstance,
  onMounted,
  onUnmounted,
  ref,
  watch,
} from "@vue/runtime-core";
import CustomSelectorWhite from "@/components/CustomSelectorWhite";
import { COUNTRIES_MAP } from "@/plugins/countries";
import { Auth } from "aws-amplify";
import { i18n } from "@/plugins/i18n";
import facebookLogin from "facebook-login-vuejs";

import { router } from "@/_helpers";
import { accountService } from "@/_services";
import CustomSelectorV2 from "../CustomSelectorV2";

export default {
  name: "Form",
  props: {
    attempt: {
      type: Number,
      required: true,
    },
    step: {
      type: Number,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
    firstName: {
      type: String,
      required: true,
    },
    lastName: {
      type: String,
      required: true,
    },
  },
  emits: ["started", "register", "onError"],
  components: {
    CustomSelectorWhite,
    CustomSelectorV2,
    facebookLogin,
  },

  methods: {
    getUserData() {
      this.FB.api(
        "/me",
        "GET",
        { fields: "id,name,email" },
        (userInformation) => {
          console.warn("Get data from FB", userInformation);
          this.personalID = userInformation.id;
          this.email = userInformation.email;
          this.name = userInformation.name;
        }
      );
    },
    sdkLoaded(payload) {
      this.isConnected = payload.isConnected;
      this.FB = payload.FB;
      if (this.isConnected) this.getUserData();
    },
    onLogin() {
      this.isConnected = true;
      this.getUserData();
    },
    onLogout() {
      this.isConnected = false;
    },
  },
  setup(props, { emit }) {
    let emailModel = ref(null);
    let firstNameModel = ref(null);
    let lastNameModel = ref(null);
    let password1 = ref(null);
    let password2 = ref(null);
    let accountType = ref("INDIVIDUAL");
    // let residence = ref(null)
    let busy = ref(false);
    let disclaimer = ref(false);
    let valid = ref(false);
    let account = ref(true);

    const websiteName = ref(process.env.VUE_APP_CABINET_V2_WEBSITE_NAME);
    const internalInstance = getCurrentInstance()
    const emitter = internalInstance.appContext.config.globalProperties.emitter
    const region = ref(process.env.VUE_APP_CABINET_ORIGIN);

    if (accountService.accountValue) {
      router.push("/");
    }

    let testValue = ref(null);
    const testOptions = ref([
      "Select option",
      "Option",
      "Mulitple",
      "Searchable",
      "Taggable",
      "Close on select",
      "Hide selected",
    ]);

    onMounted(() => {
      accountTypeOpen();

      verify2().then((result) => {
        emailModel.value = result.attributes.email;
      });

      emitter.on("successfulRequest", () => {
        // console.log('successful')
        busy.value = false;
      });

      emitter.on("failedRequest", () => {
        // console.log('failedRequest')
        busy.value = false;
      });
    });

    onUnmounted(() => {
      emitter.off("successfulRequest");
      emitter.off("failedRequest");
    });

    const accountTypeOpen = () => {
      if (
        window.location.pathname === "/register/1/live-account" ||
        window.location.pathname === "/register/2/live-account"
      ) {
        account.value = true;
      } else if (
        window.location.pathname === "/register/1/demo-account" ||
        window.location.pathname === "/register/2/demo-account"
      ) {
        account.value = false;
      }
    };

    const verify2 = async () => {
      let useremail = await Auth.currentAuthenticatedUser();
      return useremail;
    };
    const getStartedClicked = () => {
      // console.log('get started...')
      if (
        emailModel.value != null &&
        emailModel.value.length > 3 &&
        password1.value != null &&
        password1.value.length > 0 &&
        password2.value != null &&
        password2.value.length > 0
      ) {
        // let passw = /^(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        let passw = /^(?=.*?[a-z]).{6,}$/;
        let passw1 = /^(?=.*?[a-z])(?=.*?[0-9]).{6,}$/;
        let passw2 = /^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$/;

        if (password1.value.match(passw)) {
          if (password1.value.match(passw1)) {
            if (password1.value.match(passw2)) {
              busy.value = true;
              if (!disclaimer.value) {
                valid.value = true;
              } else {
                valid.value = false;
              }
              if (password1.value === password2.value) {
                if (!valid.value) {
                  // desactiva el boton get
                  let eleman = document.getElementById("btnSubConf");
                  eleman.setAttribute("disabled", true);
                  // pasa a registrar el usuaraio
                  emit(
                    "started",
                    emailModel.value,
                    password1.value,
                    disclaimer.value
                  );
                } else {
                  emit("onError", "Error", i18n.global.t("register.errorOne"));
                }
              } else {
                emit("onError", "Error", i18n.global.t("register.errorTwo"));
              }
            } else {
              emit(
                "onError",
                "Error",
                i18n.global.t("register.errorThree")
              );
            }
          } else {
            emit("onError", "Error", i18n.global.t("register.errorFour"));
          }
        } else {
          emit(
            "onError",
            "Error",
            i18n.global.t("register.errorFive")
          );
        }
      } else {
        // console.log('error in email, firstName or lastName')
        emit("onError", "Error", i18n.global.t("register.errorSix"));
      }
    };

    const registerClicked = () => {
      console.log(disclaimer.value);
      // console.log('register...')
      if (
        emailModel.value != null &&
        emailModel.value.length > 3 &&
        firstNameModel.value != null &&
        firstNameModel.value.length > 0 &&
        lastNameModel.value != null &&
        lastNameModel.value.length > 0 &&
        accountType.value != null &&
        accountType.value.length > 3
      ) {
        busy.value = true;

        // console.log(disclaimer.value);
        emit(
          "register",
          emailModel.value,
          firstNameModel.value,
          lastNameModel.value,
          accountType.value,
          disclaimer.value
        );
      } else {
        // console.log('error in email, firstName or lastName')
        emit("onError", "Error", i18n.global.t("register.errorSeven"));
      }
    };

    watch(
      () => props.email,
      (current, previous) => {
        emailModel.value = current;
      }
    );

    watch(
      () => props.firstName,
      (current, previous) => {
        firstNameModel.value = current;
      }
    );

    watch(
      () => props.lastName,
      (current, previous) => {
        lastNameModel.value = current;
      }
    );

    watch(
      () => props.attempt,
      (current, previous) => {
        // console.log('new attempt!')
        busy.value = false;
      }
    );

    const accountOptions = [
      {
        value: "INDIVIDUAL",
        text: "Individual",
      },
      // {
      //   value: 'JOINT',
      //   text: 'Joint'
      // },
      // {
      //   value: 'CORPORATE',
      //   text: 'Corporate'
      // }
    ];

    const doFederatedGoogleLogIn = () => {
      emitter.emit("federatedSignIn", {
        provider: "Google",
        code: null,
        token: null,
      });
    };

    const doFederatedFacebookLogIn = () => {
      emitter.emit("federatedSignIn", {
        provider: "Facebook",
        code: null,
        token: null,
      });
    };

    const countryOptions = COUNTRIES_MAP;

    return {
      getStartedClicked,
      doFederatedGoogleLogIn,
      doFederatedFacebookLogIn,
      registerClicked,
      accountTypeOpen,
      password1,
      password2,
      accountType,
      busy,
      emailModel,
      disclaimer,
      valid,
      firstNameModel,
      lastNameModel,
      accountOptions,
      countryOptions,
      login: accountService.login,
      websiteName,

      testOptions,
      testValue,
      account,
      region
    };
  },
};
</script>

<style scoped>
</style>
